import(/* webpackMode: "eager", webpackExports: ["default"] */ "/work/repo/app/[locale]/help-center/components/FaqResults.jsx");
